import type { TranslationKeys } from '../localeType';

export const ptPT: TranslationKeys = {
  // All Pages
  addAccessories: 'Adicionar mais acessórios',
  all: 'Todos',
  checkAll: 'Selecionar tudo',
  anyFloristFounded: 'Não foi encontrada nenhuma florista',
  backToOrderList: 'Atrás',
  cancel: 'Cancelar',
  catalog: 'Catálogo',
  catalogAbroad: 'Catálogo de produtos do estrangeiro',
  closed: 'Fechado',
  communications: 'Comunicação',
  date: 'Data',
  download: 'Descarregar',
  downloadLabel: `Baixar etiqueta`,
  endDate: 'Data de fim',
  goToOrders: 'Acesse seus pedidos',
  goToOrder: 'Aceder à encomenda',
  history: 'Histórico',
  hour: 'Hora',
  inProgress: 'Em curso',
  isModified: 'Modificato',
  isReady: 'Ramo pronto',
  ITContact: 'Contacto Interflora',
  loginAs: 'Logado como',
  modify: 'Modificar',
  new: 'Novo',
  noDocuments: 'Não foram encontrados documentos com estes filtros:',
  noOrderInTab: 'Não há encomendas neste separador',
  noOrdersFound: 'Nenhuma encomenda corresponde a esta pesquisa',
  nothingFound: `Nada encontrado`,
  open: 'Aberto',
  orderDefault: 'Encomenda',
  orders: 'Encomendas',
  partner: 'Sites parceiros',
  price: 'Preço',
  startDate: 'Data de início',
  suspendedFlorist: 'Florista não ativo',
  to: 'até',
  and: 'e',
  today: 'Hoje',
  unknown: 'Desconhecido',
  validate: 'Validar',
  save: 'Guardar',
  view: 'Ver',
  close: 'Fechar',
  actionImpossible: 'Não disponível',
  listView: 'Ver lista',
  listViewTooltip: 'Este botão permite exibir a lista',
  mapView: 'Ver mapa',
  mapViewTooltip: 'Este botão permite visualizar o mapa',
  viewOnMap: 'Ver no mapa',
  true: 'Sim',
  false: 'Não',
  delete: 'Eliminar',
  warning: 'Atenção',
  courierDeliveryOrderWarning: 'Está a agir num pedido inicialmente previsto para entrega por estafeta!',
  putOrderInProgress: 'Ativação do estado Em curso',
  removeOrderInProgress: 'Desativação do estado Em curso',
  actionUnavailable: 'Ação impossível',

  print: {
    title: 'Imprimir',
    titleQuick: 'Impressão rápida',
    printed: 'Impresso',
    printTooltip: 'Este botão permite imprimir os comprovantes de pedido que ainda não foram impressos',
    printedError: 'Ocorreu um erro, tente novamente mais tarde.',
    printedErrorMessage: 'Alguns pedidos não podem ser impressos.',
    partiallyPrinted: 'Algumas faturas não puderam ser impressas.',
    nothingToPrint: 'Nenhuma fatura para imprimir.',
    markAsPrint: 'O pedido foi marcado como impresso.',
    markAsPrintPlural: 'Os pedidos foram marcados como impressos.',
    popup: {
      title: 'Marcar como impresso?',
      titlePlural: 'Marcar como impressos?',
      validate: 'Marcar como impresso',
      validatePlural: 'Marcar como impressos',
      cancel: 'Não marcar',
      textQuickPrint: `Utilizou a impressão rápida. Deseja marcar estes pedidos como Impressos para evitar uma reimpressão através da impressão rápida?`,
      textMultiSelect: `Solicitou a impressão de vários pedidos. Deseja marcá-los como Impressos para evitar uma reimpressão através da impressão rápida?`,
      textSinglePrint: `Deseja marcar o pedido cujo comprovante acabou de consultar como Impresso para evitar uma reimpressão através da impressão rápida?`,
    },
  },

  markAsPrint: {
    validMarkAsPrint: 'Os pedidos foram marcados como impressos.',
    validUnmarkAsPrint: 'Os pedidos foram marcados como não impressos.',
    warning: 'Alguns pedidos não puderam mudar de estado',
    undoMarkAsPrint: 'Remover o estado Impresso',
    undoUnmarkAsPrint: 'Restaurar o estado Impresso',
  },

  // Homepage
  message: {
    welcome: 'Welcome, {name} \ud83c\udf3b',
  },
  ordersHome: {
    today: 'Encomendas para hoje',
    tomorrow: 'Encomendas para amanhã',
    later: 'Encomendas para mais tarde',
    late: 'Encomendas tardias',
  },
  orderHome: {
    today: 'Encomendar para hoje',
    tomorrow: 'Encomenda para amanhã',
    later: 'Encomendar para mais tarde',
    late: 'Encomenda tardia',
  },
  linkNewsLabel: 'Ver todas as notícias',
  seeMore: 'Ver mais',
  seeLess: 'Ver menos',
  seeHistory: `ver histórico`,
  NoNotification: 'Não há notificação',
  explanation: {
    title: 'Introdução ao Iris',
    content: `Bem-vindo à sua nova plataforma do florista.
Recordamos que esta não é a versão final, o nosso trabalho ainda está em curso. 
Durante esta fase, o seu feedback é crucial.
Agradecemos desde já a vossa compreensão e paciência.`,
  },
  newCollectionHome: 'A coleção do momento',

  // Nav
  nav: {
    admin: 'Minha conta',
    contact: 'Contacto',
    deliveries: 'Entregas',
    history: 'Histórico',
    home: 'Início',
    internalUser: 'Utilizador interno',
    orders: 'Encomendas',
    page: 'Minha loja',
    QrCode: 'Validação da encomenda',
    signOut: 'Sair',
    transmissions: 'Transmissões',
    faq: 'Foram feitas perguntas',
    xlFlorist: 'Florista XL',
  },

  // Orders
  details: {
    download: 'Descarregar como PDF',
    delivered: 'Conjunto como entregue',
    absent: 'Definir como ausente',
    reassign: 'Reatribuir',
    additional: 'Informações adicionais',
    accept: 'Aceitar',
    refuse: 'Recusar',
    assignToCourier: 'Atribuir a um estafeta',
    cancel: 'Cancelar encomenda',
    customerErrorMessage: 'Não é possível exibir o comprovante de pedido',
    cancelDelivery: 'Cancelar entrega',
    recipient: {
      title: 'Destinatário e dados de entrega',
      label: {
        additionalStreetInfo: 'Complemento de morada',
        address: 'Morada',
        colivex: 'Entrega na campa',
        companyName: 'Local de entrega...',
        contactName: 'Nome do contacto',
        country: 'País',
        deceasedName: 'Nome do falecido',
        deliveryDate: 'Data de entrega',
        deliveryLocation: 'Local de entrega...',
        deliveryMoment: 'Momento da entrega',
        deliveryTime: 'Prazo de entrega',
        event: 'Evento',
        infos: 'Adicionar informação',
        instructions: 'Instruções',
        name: 'Nome',
        phone: 'Número de telefone',
        postalCode: 'Código postal',
        prelimeryAgreement: 'Acordo preliminar', //not used in Portugal
        region: 'Província',
        town: 'Localidade',
      },
    },
    order: {
      title: 'Detalhes da encomenda',
      label: {
        legacyOrderId: 'ID da encomenda ISOWEB',
        orderStatus: 'Estado da encomenda',
        orderDate: 'Data da encomenda',
        price: 'Preço',
        deliveryCost: 'Custo de entrega',
        trackingCode: `Código de envio`,
      },
      status: {
        NEW_ORDER: 'Nova encomenda',
        ASSIGNED: 'Atribuído',
        ACCEPTED: 'Aceite',
        REFUSED: 'Recusada',
        ASSIGNATION_NOT_POSSIBLE: 'Não é possível a atribuição',
        NOT_PRINTED: 'Não impresso',
        PRINTED: 'Impresso',
        IN_PROGRESS: 'Em curso',
        INTERNAL_COURRIER: 'Correio interno',
        EXTERNAL_COURRIER: 'Correio externo',
        DELIVERED: 'Entregado',
        ABSENT: 'Ausente',
        CANCELLED: 'Cancelado',
        SENT: 'Enviado',
        REASSIGN: 'Reatribuído',
      },
      notes: {
        addNote: 'Adicionar a nota',
        addPhoto: 'Adicionar uma fotografia',
        anythingElse: 'Adicione a sua nota',
        create: 'Criar uma nota',
        delivery: 'Entrega',
        deliveryChanges: 'Alterações à entrega?',
        deliveryDetail: 'Especificar os pormenores da entrega',
        emptyNoteList: `Você não tem notas`,
        emptyPhotos: `Você não tem fotos`,
        imageCategory: `Categoria de imagem`,
        notValidatedNote: 'Não foi possível atualizar o estado desta encomenda',
        product: 'Produto',
        title: 'Adicionar notas',
        titleAddNotes: 'Adicionar notas',
        titleSetAsDelivered: 'Validar uma entrega',
        confirmSetAsDelivered:
          'Tem a certeza de que pretende marcar as {count} encomendas selecionadas como entregues?',
        validatedNote: 'A nota foi criada',
        validatedOrderNote: 'A encomenda foi validada',
        dragAndDrop: 'Arraste e solte a sua imagem aqui',
        or: 'ou',
        browseFiles: 'Procurar ficheiros',
        uploadPhoto: 'Enviar foto',
        addPhotoOptionnal: 'Adicionar uma foto (opcional)',
      },
      delivery: {
        inProgress: {
          status: 'Estado de entrega:',
          momentTitle: 'Data e hora: ',
          moment: '{date} - Entre {hour} e {hourPlusOne}',
          price: 'Preço:',
          from: 'por',
        },
        cancel: {
          title: 'Cancelar entrega',
          body: 'Esta ação irá cancelar o serviço de entregas externo atribuído a esta encomenda.',
          bodyInternalDelivery: 'Esta ação irá anular a entrega interna atribuída a esta encomenda.',
          buttonSecondary: 'Abandonar',
          buttonPrimary: 'Confirmar',
        },
      },
      modifications: {
        title: 'Modified order details',
        tooltip: 'Click for updates',
        modalTitle: 'Updates',
        noChanges: 'Cannot display order modifications',
        markAsRead: 'Mark as read',
      },
      invoicePrintedLabel: {
        yes: 'Impressa',
        no: 'Não impressa',
      },
      invoicePrintedTooltip: {
        yes: 'Esta encomenda foi impressa',
        no: 'Esta encomenda ainda não foi impressa',
      },
      recipientSmsStatus: {
        sent: {
          label: 'SMS enviado',
          fullLabel: 'SMS enviado',
          tooltip: 'Foi enviado um SMS de notificação ao destinatário',
        },
        resent: {
          label: 'SMS reenviado',
          fullLabel: 'SMS reenviado',
          tooltip: 'O SMS de notificação foi reenviado ao destinatário',
        },
        expired: {
          label: 'SMS expirado',
          fullLabel: 'SMS expirado',
          tooltip: 'O SMS de notificação expirou',
        },
        validatedByPhone: {
          label: 'Validado por telefone',
          fullLabel: 'Validado por telefone',
          tooltip: 'O florista validou a entrega por chamada telefónica',
        },
        validatedBySms: {
          label: 'Validado por SMS',
          fullLabel: 'Validado por SMS',
          tooltip: 'O destinatário validou a entrega através do link do SMS',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Remover validação',
        resendSms: 'Reenviar SMS',
        validateByPhone: 'Marcar como validado por chamada telefónica',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: 'O reenvio está temporariamente indisponível',
        smsAlreadyResent: 'O SMS já foi reenviado',
      },
    },
    florist: {
      title: {
        executor: 'Florista executante',
        transmitter: 'Florista transmissor',
      },
      label: {
        name: 'Nome',
        id: 'Identificador',
        Phone: 'Número de telefone.',
        Email: 'Correio eletrónico',
        SecondEmail: 'Correio eletrónico',
      },
    },

    ribbon: {
      title: 'Fita',
      text: 'Texto Ribon: ',
    },

    buyer: {
      title: 'Detalhes do comprador',
      label: {
        name: 'Nome',
        phone: 'Número de telefone.',
        email: 'Correio eletrónico',
      },
    },

    header: {
      productCode: 'Código de produto',
      quantity: 'Quantidade',
      size: 'Tamanho',
      description: 'Descrição',
      price: 'Preço',
      image: 'Imagem',
      composition: 'Composição',
      moreProducts: 'Mais produtos',
      accessory: 'Acessórios',
    },
    message: {
      title: 'Cartão de mensagem',
      label: {
        message: 'Mensagem',
        signature: 'Assinatura',
      },
    },
    addInfo: 'Adicionar notas',
    additionalImages: 'Fotos guardadas',
    recipientNotes: {
      title: 'Notas do destinatário',
      cardTitle: 'Nota do destinatário',
      cardTitleModified: 'Nova nota do destinatário',
      canBeLeft: 'O pedido pode ser deixado sem vigilância.',
      cannotBeLeft: 'O pedido não pode ser deixado sem vigilância.',
    },
  },

  // Transmissions
  transmission: {
    title: 'Encomendar transmissões',
    new: 'Nova transmissão:',
    locale: 'Local',
    abroad: `No estrangeiro`,

    table: {
      no: 'Não.',
      id: 'Número de encomenda',
      product: 'Produto',
      recipient: 'Destinatário',
      town: 'Localidade',
      status: 'Estado',
      date: 'Data',
    },
    form: {
      deliveryAddressCemeteryWarning: `O endereço de entrega parece ser um cemitério, mas a opção 'Entrega no Túmulo' não está selecionada. Deseja continuar?`,
      cemetery: 'cemitério',
      sended: 'O formulário foi enviado com sucesso',
      notSended: 'O formulário não foi enviado',
      country: 'País',
      mandatoryFields: 'Campos obrigatórios',
      noProductsForCountry: 'Não foram encontrados produtos para este país',
      freePrice: {
        title: 'Preço gratuito',
        low: 'Preço gratuito demasiado baixo',
        entry: 'Introduzir um preço gratuito',
        from: 'Produto com preço livre possível a partir de',
        integer: `os cêntimos não são aceites pelo sistema internacional`,
      },
      emailNotValid: 'O correio eletrónico não é válido. exemplo: %{email}',
      phoneNotValid: `Número de telefone não é válido`, //. exemplo: %{phone}
      delivery: {
        additionalStreetInfo: 'Complemento de morada',
        address: 'Morada',
        addressComplement: 'Informações adicionais',
        city: 'Cidade',
        cityPostalCode: 'Cidade ou código postal',
        deliveryInstructions: 'Instruções de entrega',
        extra: 'Extra',
        feasible: 'É possível efetuar esta encomenda!',
        foreignAddress: `Como os endereços estrangeiros não podem ser verificados, por favor insira o endereço mais completo possível`,
        guarantee: '*Apenas o dia é garantido',
        isBillNeeded: `Preciso de uma conta`,
        isCeremony: 'É para uma cerimónia?',
        no: 'Não',
        notFeasible: 'Não há correspondência possível para esta ordem!',
        notFound: ' Endereço não encontrado',
        place: 'Nome do local',
        psm: 'Informações personalizadas sobre o produto',
        slot: 'Slot de entrega',
        streetName: 'Nome da rua',
        streetNumber: 'Número da rua',
        title: 'Detalhes da entrega',
        toGrave: 'Entregar à sepultura',
        yes: 'Sim',
        zipCode: 'Código postal',
        errorAddressAndLocality: `O endereço não corresponde ao destino {locality} selecionado acima`,
        date: {
          title: 'Data de entrega',
          today: `Hoje`,
          tomorrow: 'Amanhã',
          later: 'Mais tarde',
          selectedDate: 'Data selecionada:',
        },
      },

      productDetail: 'Detalhe do produto',
      selectSize: 'Selecionar tamanho',
      orderType: {
        title: 'Tipo de encomenda',
        regular: 'Normal',
        funeral: 'Funeral',
      },
      contact: {
        additionalStreetInfo: 'Informações adicionais',
        address: 'Morada',
        buyerTitle: 'Detalhe do comprador',
        city: 'Cidade',
        companyName: 'Nome da empresa',
        contactTitle: 'Dados de contacto',
        deceased: 'Falecido',
        email: 'Correio eletrónico',
        firstName: 'Nome próprio',
        fiscalCode: 'Código fiscal',
        lastName: 'Apelido',
        phone: 'Telefone',
        title: 'Dados de contacto',
        zipCode: 'Código postal',
      },
      message: {
        title: 'Dados do cartão de mensagem',
        message: 'Mensagem do cartão',
        signature: 'Assinatura',
      },
      accessory: {
        addAccessory: 'Acrescentar acessório',
        addMoreAccessories: 'Acrescentar mais acessórios',
        changeAccessory: 'Alterar',
        label: 'Acessório',
        noAccessory: 'Nenhum acessório selecionado',
        removeAccessory: 'Remover',
        select: 'Selecionar um acessório',
        title: 'Detalhes do acessório',
        needRibbonText: 'Acrescentar uma fita?',
        ribbonText: 'Introduzir o texto da faixa de proteção',
      },
      summary: {
        title: 'Resumo: ',
        productTotal: 'Total do produto:',
        accessoriesTotal: 'Total acessórios:',
        deliveryCost: 'Montante da entrega:',
        total: 'Total: ',
        transmissionFormComplete: 'O formulário de transmissão está completo',
        stepper: {
          productDetails: 'Detalhes do produto',
          deliveryAddress: 'Endereço de entrega',
          deliveryDate: 'Data de entrega',
          feasability: 'Viabilidade',
          recipientInfo: 'Informações do destinatário',
          buyerInfo: 'Informações do comprador',
          feasabilityOK: 'Pedido viável',
        },
      },
      assignation: {
        title: 'Atribuição de florista',
        select: `Selecionar o tipo de atribuição`,
        zone1: 'Principal',
        zone2: 'Reserva',
        zone3: 'Zona grande',
        displayZone3: 'Exibir lista de ',
        automatic: 'Automático',
        manual: 'Manual',
        floristNumber: 'Número do florista',
        floristNumberError: `O formato do número de membro não é o esperado`,
        floristNumberSupporting: 'O número de membro deve começar por 00',
        validationCode: 'Código de validação',
        mandatoryValidationCode: 'Código de validação obrigatório para este produto',
        table: {
          floristName: 'Nome do florista',
          phone: 'Número de telefone',
          distance: `distância`,
          quality: 'Bónus de qualidade',
        },
      },
      color: {
        select: 'Selecionar uma cor',
        nbOfFlowers: 'Número de flores',
        price: 'Preço',
      },
      psp: {
        title: 'Pagamento',
        paymentOK: 'Pagamento realizado com sucesso! Agora você pode continuar com a transmissão.',
        paymentKO: 'Falha no pagamento',
        paymentLinkExprired: 'O link de pagamento expirou. Por favor, gere um novo selecionando o tipo de pagamento.',
        linkAlreadyExist:
          'Parece que você já gerou um link de pagamento com cartão bancário. Certifique-se de que o cliente não o utilizará novamente para evitar um pagamento duplicado.',
        linkTime: 'Tempo restante antes da expiração do link de pagamento: {time}',
        paymentDone: 'Pagamento efetuado, a transmissão será enviada automaticamente',
        selectPayment: {
          title: 'Selecionar tipo de pagamento',
          cash: 'Dinheiro',
          bankCard: 'Cartão bancário',
        },
        paymentLink: {
          title: 'Escolha como enviar o link de pagamento ao cliente',
          otherTab: 'Abrir em nova aba',
          sms: 'Enviar SMS',
          QrCode: 'Gerar código QR',
        },
        otherTab: {
          title: 'Link de pagamento em outra aba',
          explaination:
            'A página de pagamento será aberta em uma nova aba para o cliente. Informaremos quando o pagamento for concluído ou expirado para que você possa continuar.',
        },
        sms: {
          send: 'Enviar SMS',
          title: 'Link de pagamento por SMS',
          explaination:
            'Um link de pagamento foi enviado ao cliente por SMS. Informaremos quando o pagamento for concluído ou expirado para que você possa continuar.',
          smsSendError: 'Ocorreu um erro ao enviar o SMS',
          smsSendImpossible: `O envio do SMS é impossível`,
          paymentLinkMessage:
            'A Interflora agradece a sua confiança. Aqui está o link para o pagamento do seu pedido. ',
        },
        qrCode: {
          title: 'Link de pagamento via código QR',
          explaination:
            'O cliente pode escanear o código QR para acessar o link de pagamento. Assim que o pagamento for concluído ou expirado, informaremos para que você possa continuar com a transmissão.',
        },
      },
    },
    quickCheck: {
      title: 'Verificar um destino',
      label: 'Selecione um destino',
      notFeasible: 'Este destino não está disponível para encaminhamento.',
      feasible: `Este destino está disponível para encaminhamento. 
Clique em « Continuar o encaminhamento » para acessar o formulário.`,
      accessForm: 'Continuar o encaminhamento',
    },
  },

  // OrderList
  delivered: 'Entregado',
  absent: 'Ausente',
  seeDetails: 'Ver detalhes',
  hideDetails: 'Ocultar detalhes',
  order: {
    search: 'O que é que procuram?',
    searchTooltip: 'Este botão permite realizar uma pesquisa de encomendas',
    loadingOrders: 'A carregar encomendas...',
    quickActions: {
      delivered: 'Entregado',
      assignToCourier: 'Atribuir ao transportador',
      absent: 'Destinatário ausente',
      reassign: 'Reatribuir',
      accept: 'Aceitar',
      refuse: 'Recusar',
      clear: 'Opções claras',
      tooLate: 'Tarde demais para aceitar',
      acceptAndPrint: 'Aceitar e imprimir',
      downloadCSV: 'Descarregar CSV',
      print: 'Imprimir',
      noOrderSelected: 'Selecione várias encomendas para efetuar ações em grupo',
      noOrderSelectedShort: 'Nenhuma encomenda selecionada',
      openToolbar: 'Abrir multi-seleção',
      closeToolbar: 'Cancelar multi-seleção',
      ordersSelected: '{nbOrders} encomendas selecionadas',
      acceptAll: 'Aceitar toda a seleção',
      acceptAndPrintAll: 'Aceitar e imprimir',
      cancelDelivery: 'Cancelar entrega',
      feedback: {
        cancelDeliveryOK: `A entrega externa foi cancelada com sucesso e o pedido foi movido para o separador de pedidos.`,
        cancelInternalDeliveryOK: `A entrega interna foi cancelada com sucesso e a encomenda foi transferida para o separador das encomendas.`,
        cancelDeliveryKO: `Não foi possível cancelar a entrega externa.`,
        cancelInternalDeliveryKO: `Não é possível cancelar a entrega interna.`,
      },
    },
    title: 'Lista de encomendas',
    noStatusBanner: {
      mainText: `{count} encomenda cujo fim da janela de entrega se aproxima não tem o estado "Entregue" ou "Destinatário ausente". | {count} encomendas cujo fim da janela de entrega se aproxima não têm o estado "Entregue" ou "Destinatário ausente".`,
      subText: `Por trás de cada encomenda, alguém espera saber se as suas flores chegaram bem. Pensou em atualizá-las?`,
    },
    table: {
      no: 'Não.',
      deliveryDate: 'Data de entrega',
      deliveryTime: 'Prazo de entrega',
      id: 'Número de encomenda',
      product: 'Produto',
      price: 'Preço',
      town: 'Localidade',
      recipient: 'Destinatário',
      preparing: 'Em curso',
      invoice: 'Faturas',
      actions: 'Acções',
      deliveryService: 'Serviço de entrega',
      reason: 'Motivo',
      openDetail: 'Abrir detalhe',
      closeDetail: 'Fechar detalhe',
      deliveryDetails: 'Detalhes de entrega',
      address: 'Endereço',
      phone: 'Número de telefone',
      goToOrderDetail: 'Ir para a página de detalhe do pedido',
      instructions: 'Instruções de entrega',
    },
    modal: {
      refuse: {
        title: 'Pretende recusar esta encomenda?',
        reason: {
          reason1: 'O preço é demasiado baixo',
          reason2: 'A minha loja está fechada',
          reason3: `Não consigo entregar`,
          reason4: `Não tenho este produto`,
        },
      },
      absent: {
        title: 'Porque é que a encomenda não pôde ser entregue?',
        subtitle: 'Porque é que a encomenda não pôde ser entregue?',
        reason: {
          DANOREP: 'Destinatário inacessível',
          DADATEULT: 'O destinatário alterou a data de entrega',
          DAREFUS: 'O destinatário recusou o pedido',
          DANOINFO: 'Faltam informações para entregar o pedido',
        },
      },
      reassign: {
        title: 'Deseja reatribuir este pedido?',
        reason: {
          PCO: 'Faltam as cores obrigatórias',
          PFO: 'Faltam as flores obrigatórias',
          PL: 'Sem entregador disponível',
          LL: 'Entrega muito distante',
          RT: 'Recebido muito tarde',
          PAM: 'Sem mais estoque na loja',
        },
      },
      delivery: {
        title: 'Selecionar um serviço de entrega',
        intro: 'Selecionar um serviço de entrega para a encomenda <b>{orderId}</b>.',
        introMultiOrders: 'Escolha um serviço de entrega para as {count} encomendas.',
        deliveryCost:
          'Custo {deliveryService}({serviceAmount}) - Taxa de entrega({itfAmount}) = Out of pocket({totalPrice})',
        delay: 'Disponível em {noticePeriod}',
        availableImmediately: 'Disponível imediatamente',
        includedDeliveryPrice: 'Incluído no seu pacote de entrega',
        serviceUnavailable: 'Serviço indisponível',
        selectYourSlot: 'Escolher a faixa horária',
        deliverOrder: 'Entregar a encomenda {orderId}',
        deliveryInstructions: 'Qualquer coisa que facilite a entrega',
        validated: `Ordem {orderId} é enviada para {service} !Verificar o estado da entrega no separador da entrega`,
        internalValidated: `A encomenda é atribuída à {username} e é transferida para o separador de entregas.`,
        internalMultipleOrdersValidated: `As encomendas são atribuídas ao {username} e transferidas para o separador de entregas.`,
        errorOnValidation: 'Não foi possível criar uma entrega para a encomenda {orderId}',
        errorOnMultipleOrdersValidation: 'Não é possível criar a entrega das encomendas.',
        dateTooFar: `A data de entrega proposta está muito distante. Por favor, tente novamente dentro de alguns dias.`,
      },
    },
    multiSelect: {
      delivered: {
        allDelivered:
          '{count} encomendas foram marcadas como entregues com sucesso. Foram movidas para o histórico de encomendas.',
        someNotUpdated: 'Algumas das suas encomendas não puderam ser atualizadas.',
        noneUpdated: 'Nenhuma das encomendas selecionadas mudou de estado.',
      },
      accept: {
        all: '{count} encomendas foram aceites com sucesso. Foram agora movidas para o separador de encomendas.',
        someNotUpdated: 'Algumas das suas encomendas não puderam ser aceites.',
        noneUpdated: 'Nenhuma das encomendas selecionadas foi aceite.',
        waiting: 'Processamento em curso, por favor aguarde...',
      },
    },
    floristToggle: {
      changeStateTooltip: 'Alterar o estado da encomenda',
      backToInitial: 'Voltar ao estado inicial',
      initial: {
        label: 'Inicial',
      },
      inProgress: {
        label: 'Em progresso',
      },
      ready: {
        label: 'Ramo pronto',
        lockedHint: 'Disponível apenas 2 horas antes do período de entrega',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} / página',
  },

  // My page
  myPage: {
    title: 'Minha página',
    calendarManagement: 'Gestão do calendário',
    notFound: 'Informações sobre a florista não encontradas',
    infoManagement: 'Gestão de informação',
    accessories: {
      accessoriesAction: 'Disponibilidade',
      accessoriesList: 'Lista de acessórios',
      anyAccessory: 'Sem acessórios',
      title: 'Gestão de acessórios',
    },
    hours: {
      title: 'Horário de funcionamento',
      changeOpeningHours: 'Alterar o seu horário de funcionamento',
      closeAllDayButton: 'Fechar todo o dia',
      shopClosed: 'A sua loja está fechada hoje',
      openButton: 'Aberto',
      addBreak: 'Acrescentar uma pausa',
      removeBreak: 'Remover o intervalo',
      saveButton: 'Guardar',
      closingTime: 'Hora de fecho',
      openingTime: 'Horário de abertura',
      breakEnd: 'Fim do intervalo',
      breakStart: 'Início do intervalo',
    },
    exceptions: {
      headerTitle: 'Minhas exceções',
      the: 'Le :',
      from: 'De:',
      new: 'Adicionar uma exceção',
      next: 'Próximas excepções',
      any: `Sem exceção`,
      title: 'Próximas excepções',
      to: 'Para:',
    },
    calendar: {
      title: 'Visão geral mensal',
      weeklyCalendar: {
        calendarModified: 'O seu calendário foi modificado com sucesso',
        clickToChange: 'Clique para abrir ou fechar*',
        closed: 'Fechado',
        closedAM: 'Fechado de manhã',
        closedPM: `Fechado à tarde`,
        editWeek: 'Edite sua programação semanal',
        open: 'Aberto todo o dia',
        openAM: 'Aberto de manhã',
        openPM: `Aberto à tarde`,
        title: 'Calendário Semanal',
      },
      massive: {
        title: 'Adicionar excepções massivas',
        years: 'Anos',
        months: 'Meses',
        days: 'Dias',
        morning: 'manhã',
        afternoon: 'Tarde',
        exceptionsSended: 'Exceções enviadas com sucesso',
        exceptionsNotSended: `As excepções não podem ser registadas`,
      },
    },
    quality: {
      bonus: 'Bônus de qualidade',
      note: 'Sua nota',
      noteMini: 'Nota mínima',
      noteMaxi: 'Nota máxima',
      endPeriod: 'Fim de validade',
      explainationTitleToMM: 'Meu bônus de qualidade e Minhas reatribuições',
      explainationToMM: `As seções « Meu bônus de qualidade » e « Minhas reatribuições » ainda não estão disponíveis no Iris.
Ao clicar nos botões correspondentes, você será redirecionado para o Mon magasin, onde elas estão acessíveis.`,
      claims: {
        deliveryDate: 'Data',
        orderId: 'Número do Pedido',
        productCode: 'Produto',
        reason: 'Motivo',
        explainationTitleToMM: 'A página « Acompanhamento do meu desempenho » está em construção',
        explainationToMM: 'Em breve reunirá todos os seus indicadores-chave num painel completo e melhorado.',
      },
      title: {
        general: 'Geral',
        advertissement: 'Publicidade / Promoção da Marca',
        quality: 'Qualidade do Serviço',
        availability: 'Disponibilidade',
        tools: 'Ferramentas',
      },
    },
    noStock: 'Atualmente você não tem estoque',
    supplies: {
      title: 'Fornecimentos',
      seeCart: 'Ver e validar meu pedido',
      yourOrders: 'Seus pedidos',
      emptyCart: 'Esvaziar o carrinho',
      chooseSupplies: 'Escolher fornecimentos',
      modifyChooseSupplies: 'Modificar e escolher os fornecimentos',
      orderSupplies: 'Pedidos de fornecimentos',
      explainationTitleToMM: 'I tuoi ordini di forniture arriveranno presto su IRIS',
      explainationToMM: `Le sezioni « Ordini di forniture » e « I miei ordini di forniture » non sono ancora disponibili su IRIS.
Cliccando sui pulsanti corrispondenti, verrai reindirizzato a Mon magasin, dove potrai visualizzare e gestire i tuoi ordini di forniture.`,
      modal: {
        add: 'Adicionar',
        freeArticles: 'Administrativos (gratuitos)',
        paidArticles: 'Técnicos - Interflora (pagos)',
        productCode: 'Referência',
        image: 'Pré-visualização',
        label: 'Etiqueta',
        VTACode: 'Código IVA',
        price: 'Preço unitário',
        action: 'Ação',
      },
      panel: {
        cart: 'Meu carrinho',
        emptyCart: 'Seu carrinho está vazio',
        total: 'Total : ',
        noOrders: 'Você não tem pedidos',
      },
    },
    contact: {
      mail: 'Seu e-mail',
      mail2: 'Seu e-mail complementar',
      validationCode: 'Seu código de validação',
      address: 'Seu endereço',
      phone: 'Seu número de telefone',
    },
    networkContact: {
      title: 'O seu animador de rede',
      mail: 'O seu e-mail',
      name: 'O seu nome',
      phone: 'O seu número de telefone',
      phoneAppointment: 'Marcar uma consulta telefónica',
    },
    exclusions: {
      title: 'Minhas exclusões',
      list: 'Minha lista de exclusões',
      empty: 'Você não tem exclusões',
    },
    claims: {
      title: 'Minhas reclamações',
      empty: 'Parabéns! Você não tem nenhuma reclamação registrada nos últimos 12 meses',
    },
    reassignations: {
      title: 'Minhas reatribuições',
      empty: 'Você não tem nenhuma reatribuição registrada nos últimos 6 meses',
    },
  },

  info: {
    addHolidaysKO: `Não é possível adicionar este período de encerramento`,
    addHolidaysOK: `Período de encerramento adicionado`,
    delHolidaysKO: 'Não é possível eliminar este período de encerramento',
    delHolidaysOK: `Período de encerramento suprimido`,
    documentKO: 'Não é possível visualizar este documento',
    documentOK: 'O documento foi aberto numa outra janela',
    pending: `Procura em curso`,
    documentPending: `Documento atual a abrir, por favor aguarde`,
    editField: 'editar campo',
    nophone: 'Adicione um número de telefone',
    nosecondMail: 'Adicione um email',
    nopersonalCode: 'Adicione um código pessoal',
    statusKO: 'Não é possível atualizar o estado',
    statusOK: 'Estado atualizado',
    updatePersonalCodeKO: 'Não foi possível atualizar o código pessoal',
    updatePersonalCodeOK: 'Código pessoal atualizado',
    updatePhoneKO: 'Não é possível atualizar o telefone',
    updatePhoneOK: 'Telefone atualizado',
    updateSecondEmailKO: `Não foi possível atualizar o e-mail`,
    updateSecondEmailOK: 'E-mail atualizado',
    updateStockKO: `Não foi possível atualizar o stock`,
    updateStockOK: 'Stock atualizado',
    postSupplyOK: 'Pedido enviado',
    postSupplyKO: 'Pedido impossível',
    duplicateHolidays: 'Já existe um encerramento previsto para este período.',
    photoUploadOK: 'Foto guardada',
    photoUploadKO: `Não foi possível guardar a foto`,
    photoUploadTooBig: 'A foto é demasiado grande. Por favor, carregue uma foto com menos de 5 MB.',
    reassignOK: 'Encomenda reatribuída, será redirecionado para a lista de encomendas',
    reassignKO: 'Reatribuição impossível',
  },

  days: {
    initiale: { 1: 'T', 2: 'Q', 3: 'Q', 4: 'S', 5: 'S', 6: 'D', 0: 'S' },
    short: { 1: 'Seg', 2: 'Ter', 3: 'Qua', 4: 'Qui', 5: 'Sex', 6: 'Sáb', 7: 'Dom' },
    0: 'Segunda-feira',
    1: 'Terça-feira',
    2: 'Quarta-feira',
    3: 'Quinta-feira',
    4: 'Sexta-feira',
    5: 'Sábado',
    6: 'Domingo',
  },
  moment: {
    0: 'Manhã',
    1: 'Tarde',
    2: 'Todo o dia',
    3: 'Noite',
    hour: {
      0: '10h-15h',
      1: '17h-21h',
      2: '10h-21h',
      3: '',
    },
  },
  openingMoment: {
    0: 'Fechado o dia todo',
    1: 'Aberto pela manhã',
    2: `Aberto à tarde`,
    3: 'Aberto o dia todo',
    4: 'Feriado público',
    5: 'Feriado regional',
    6: 'Dia de abertura obrigatória',
  },
  dropdown: {
    label: {
      accessory: 'Escolha o seu acessório',
      bouquet: 'Escolher o bouquet',
      city: 'Introduzir a cidade',
      country: 'Selecionar o país',
      loginAs: 'Introduzir código de florista',
      mail: 'Introduza o seu e-mail',
      messageContent: 'Introduza a sua mensagem',
      noteCategory: 'Categoria de nota',
      photoCategory: 'Categoria da foto',
      occasion: 'Escolher a ocasião',
      receiveAnswerAt: 'Receberá a resposta em',
      select: 'Escolher o motivo',
      selectCategory: 'Selecionar categoria',
      time: 'Escolher a altura do dia',
      type: 'Seleccione o tipo',
      year: `Seleccione o ano`,
      search: 'Procurar...',
      locality: 'Escolha o destino',
    },
    code: {
      ALL: 'All',

      // OBJECT OF THE MESSAGE
      B2B: 'Encomendas comerciais B2B',
      CALL: 'Pedido de contacto de um vendedor',
      CANCEL: 'Gostaria de cancelar a minha encomenda',
      CLAIM: 'Reclamações/contestações',
      HELP: ' Assistência Iris',
      INDEMNITY: 'Perguntas sobre a declaração de remuneração',
      INFO: `Preciso de informações para processar uma encomenda`,
      QUALITY: 'Bónus de qualidade',
      SHOP1: 'A sua loja (eliminação/cessação/novo contacto)',
      SHOP2: 'A sua loja (acessórios/placa de sinalização)',
      SUPPLY: 'Pedido de fornecimento',

      // MOMENT
      0: 'Manhã',
      1: 'Tarde',
      2: 'Todo o dia',
      AFTERNOON: 'Tarde',
      DAY: 'Todo o dia',
      MORNING: 'Manhã',

      // EVENT
      BABY: 'Novo bebé',
      BIRTHDAY: 'Aniversário',
      CONGRATULATIONS: 'Felicitações',
      FUNERALS: 'Funeral',
      JUSTBECAUSE: 'Só porque sim (só por diversão)',
      OTHER: 'Outro motivo',
      WEDDING: 'Casamento',
      WELLSOON: 'Melhoras rápidas',

      // MAIL REASONS
      ADMIN: 'Pergunta sobre a minha administração',
      HARDWARE: 'Pergunta sobre um problema no PC',
      INVOICEINCIDENT: 'Incidente com fatura',
      ORDER: 'Pergunta sobre uma encomenda',
      ORDERINCIDENT: 'Incidente com a encomenda',
      ORDERMATERIAL: 'Encomenda de material',
      PARTNER: 'Pergunta sobre a minha parceria',
      SUGGESTION: 'RFazer uma sugestão',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Carrinho de encomendas',
      IT_DOC_ORDER_RECEIVER: 'Recetor de encomendas',
      IT_DOC_ORDER_SENDER: 'Pedido de compra do cliente',
      IT_INVOICE_BALANCE: 'Saldo da fatura(2024)',
      IT_INVOICE_PURCHASE: 'Fatura de compra(2024)',
      IT_INVOICE_VENDOR: 'Fatura do fornecedor(2024)',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'Fatura de retificação de comissões',
      SP_INVOICE_COMMISSIONS: `Facturas de honorários/comissões de compras para floristas`,
      SP_INVOICE_EXECUTIONS_RECTIFY: `Facturas de compra corretivas de execuções`,
      SP_INVOICE_EXECUTIONS: `Facturas de execução de compras`,
      SP_INVOICE_EXTRACT: 'Documento de compensação sumário',
      SP_INVOICE_MATERIAL: 'Fatura de material',
      SP_INVOICE_QUOTAS: `Taxas de faturação mensal de floristas de vendas/facturas de correção`,
      SP_INVOICE_CSI_SALES: 'Fatura (pedidos concluídos)',
      SP_INVOICE_QUOTAS_RECTIFY: 'Quotas de faturação rectificadas',
      PT_SAFT: 'Saft',
    },
  },

  notification: {
    title: 'Notificações',
    label: {
      order: 'nova ordem',
      orderPlural: 'novas encomendas',
      transmission: 'transmissão',
      transmissionPlural: 'transmissões',
      review: 'avaliaçãoo',
      reviewPlural: 'comentários',
      modification: 'modificação',
      modificationPlural: 'alterações',
      cancellation: 'anulação',
      cancellationPlural: 'anulações',
      refused: 'encomenda recusada',
      refusedPlural: 'encomendas recusadas',
      expired: 'encomenda expirada',
      expiredPlural: 'encomendas expiradas',
    },
    message: {
      hideNotification: 'Ocultar notificação',
      more: 'Ver mais',
      orderPlural: 'Ver lista de encomendas',
      transmissionPlural: 'Ver lista de transmissões',
      reviewPlural: 'Ver comentários',
      modificationPlural: 'Ver lista de encomendas',
      cancellationPlural: 'Ocultar notificação',
      refusedPlural: 'Ocultar notificação',
      expiredPlural: 'Ocultar notificação',
    },
    markAllAsRead: 'Marcar tudo como lido',
  },

  mail: {
    from: 'Mensagem do florista: ',
    subject: 'Assunto: ',
    body: 'Mensagem: ',
    sended: 'E-mail enviado',
    notSended: `Erro no envio de correio eletrónico`,
  },

  billing: {
    notAllowed: 'Não está autorizado a ver estas informações',
    header: {
      id: 'Número',
      date: 'Data',
      numberOfTransmission: 'Número de transmissãos',
      amount: 'Montante',
      type: 'Tipo',
      file: 'Ficheiro',
    },
  },
  filter: {
    all: 'Todos',
    today: 'Hoje',
    tomorrow: 'Amanhã',
    later: 'Mais tarde',
    past: 'Passado',
    toPrepare: 'Encomendas',
    inDelivery: 'Entrega',
    absent: 'Ausente',
    toAccept: 'A aceitar',
    inProgress: 'Em curso',
    late: 'Tarde',
    delivered: 'Entregue',
    activity: 'A minha atividade',
    financial: 'As minhas compensações',
    profiles: 'Os meus estafetas',
    activCourier: 'Estafetas ativos',
    inactivCourier: 'Estafetas inativos',
    allCourier: 'Todos os estafetas',
    legal: 'Documentos legais',
    manageStore: 'Gerenciar minha loja',
    bonus: 'Bônus de qualidade',
    customer: 'Comprovante de pedido do cliente',
    executingForm: 'Formulário de Execução de Encomenda',
    IT_DOC_ORDER_CART: 'Carrinho de encomendas',
    IT_DOC_ORDER_RECEIVER: 'Recetor de encomendas',
    IT_DOC_ORDER_SENDER: 'Pedido de compra do cliente',
    IT_INVOICE_BALANCE: 'Saldo da fatura(2024)',
    IT_INVOICE_PURCHASE: 'Fatura de compra(2024)',
    IT_INVOICE_VENDOR: 'Fatura do fornecedor(2024)',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'Fatura de retificação de comissões',
    SP_INVOICE_COMMISSIONS: `Facturas de honorários/comissões de compras para floristas`,
    SP_INVOICE_EXECUTIONS_RECTIFY: `Facturas de compra corretivas de execuções`,
    SP_INVOICE_EXECUTIONS: `Facturas de execução de compras`,
    SP_INVOICE_EXTRACT: 'Documento de compensação sumário',
    SP_INVOICE_MATERIAL: 'Fatura de material',
    SP_INVOICE_QUOTAS: `Taxas de faturação mensal de floristas de vendas/facturas de correção`,
    SP_INVOICE_CSI_SALES: 'Fatura (pedidos concluídos)',
    SP_INVOICE_QUOTAS_RECTIFY: 'Quotas de faturação rectificadas',
    PT_SAFT: 'Saft',
  },

  size: {
    label: 'Selecionar tamanho',
    0: 'Preço único',
    1: 'Pequeno',
    2: 'Grande',
    3: 'Extra grande',
    4: 'Preço gratuito',
    Standard: 'Normal',
    Premium: 'Prémio',
    Deluxe: 'Deluxe',
    one_size: 'Preço único',
    small: 'Pequeno',
    medium: 'Grande',
    large: 'Extra grande',
    null: 'Dependendo do preço',
    Normal: 'Pequeno',
    Grande: 'Grande',
    Superior: 'Extra grande',
    Pequeño: '',
    Médio: '',
    Médium: 'Grande',
    Petit: 'Pequeno',
  },

  deliveryMode: {
    CEREMONY: 'Cerimónia',
    NO_ADDRESS: `Sem endereço`,
    SELF: 'Próprio',
    STANDARD: 'Normal',
    TOMB: 'Funeral',
    FUNERAL_PLACE: 'Funeral',
    GRAVE: 'Funeral',
  },

  error: {
    floristUnknown: {
      title: 'Identificador desconhecido',
      body: `A conta atual não é válida: clique no botão de terminar sessão e escolha outra conta.`,
      button: 'Se desconectar',
    },
    noCountryCode: {
      title: 'Código do país desconhecido',
      body: `Código de país desconhecido: clique no botão de terminar sessão e seleccione outra conta.`,
      button: 'Se desconectar',
    },
  },

  soon: {
    kpi: 'Em breve, encontre aqui os KPIs da sua empresa',
    hourly: 'Em breve, encontre o seu horário de funcionamento aqui',
  },

  color: {
    blue: 'Azul',
    green: 'Verde',
    mixed: 'Multicolor',
    orange: 'Laranja',
    pink: 'Cor-de-rosa',
    purple: 'Roxo',
    red: 'Vermelho',
    silver: 'Prata',
    white: 'Branco',
    yellow: 'Amarelo',
  },

  multiproducts: 'productos',
  QrCode: {
    200: 'A encomenda foi entregue',
    400: 'Não é possível definir o estado da encomenda como entregue',
    500: 'Ocorreu um erro, por favor contacte a Interflora',
  },

  internalUser: {
    any: 'Nenhum florista selecionado',
    backToAdmin: 'Voltar à área de administrador',
    loggedIn: 'Você está conectado como',
    login: 'Login',
    needId: 'Tem de estar ligado a uma florista para ver esta informação',
    placeholder: 'Introduzir o código da florista',
    title: 'Iniciar sessão como',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Agendada',
    booked: 'Tomado a cargo',
    pending: 'À procura de entregador',
    picking: 'Entregador na rota',
    almost_picking: 'Entregador próximo',
    waiting_at_pickup: 'À espera de recolha',
    delivering: 'Em entrega',
    almost_delivering: 'Perto do local de entrega',
    waiting_at_dropoff: 'À espera de entrega',
    delivered: 'Entregue',
    no_courier_available: 'Nenhum estafeta disponível',
    cancelled: 'Entrega cancelada',
  },

  calendarExceptionType: {
    CountryForceOpen: 'Abertura obrigatória',
    CountryHolidays: 'feriados do país',
    DefaultDates: 'Aberto',
    FloristCloseOnlyAfternoon: 'Fechado apenas à tarde',
    FloristCloseOnlyMorning: 'Fechado apenas de manhã',
    FloristHoliday: 'Feriados',
    FloristOpenOnlyAfternoon: 'Aberto apenas à tarde',
    FloristOpenOnlyMorning: 'Aberto apenas de manhã',
    FloristOpenWholeDay: 'Aberto',
    RegionalHoliday: 'Feriado regional',
  },

  month: {
    1: 'Jan',
    2: 'Fev',
    3: 'Tue',
    4: 'Abr',
    5: 'maio',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Set',
    10: 'Out',
    11: 'Nov',
    12: 'Dec',
  },
  lastsMonth: 'Últimos 12 meses',
  kpi: {
    labelBestSeller: 'Número de vendas',
    labelExecution: 'Montante das execuções',
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Número de recusas',
    thisMonth: 'Este mês',
    titleBestSeller: 'Os seus mais vendidos',
    titleExecution: 'As minhas execuções',
    tooltipExecution: `Número de execuções`,
    noDataPeriod: 'Não há dados para este período',
    month: {
      0: 'Jan',
      1: 'Fev',
      2: 'Tue',
      3: 'Abr',
      4: 'maio',
      5: 'Jun',
      6: 'Jul',
      7: 'Ago',
      8: 'Set',
      9: 'Out',
      10: 'Nov',
      11: 'Dec',
    },
  },

  locality: {
    FR: 'France Métropolitaine',
    CORSE: 'Corse',
    DOMTOM: 'Drom-Com',
  },

  compensation: {
    explanation: '',
    title: 'Minha compensação para ',
    fortnight: {
      1: 'Primeira quinzena',
      2: 'Segunda quinzena',
    },
    login: {
      title: 'Acesso restrito',
      secretCode: 'Código secreto:',
      placeholder: '12345',
      error: 'Código secreto incorreto',
    },
    recette: {
      download: 'Download results of',
    },
  },

  capping: {
    title: 'Capacidade de execução',
    adjustCapping: 'Ajustar o limite de capacidade',
    daysBeforeEvent: `O evento ocorre em {count} dia{plural}`,
    needToBeSuperior: `Durante este período, não é possível reduzir o limite abaixo de {minCapping}. Por favor, ajuste o valor.`,
    ordersLeft: `Faltam {ordersLeft} pedidos para atingir o limite! Considere aumentar o limite máximo.`,
    noOrdersLeft: `Você atingiu sua capacidade máxima de execução. Considere aumentar o limite máximo.`,
  },

  xlPage: {
    productsStock: {
      action: 'Ação de produtos',
      list: 'Lista de produtos',
      anyProduct: 'Sem produtos',
      title: 'Gestão de produtos',
      selection: {
        flower: 'Flores',
        gift: 'Presentes',
      },
    },
  },

  internalCourier: {
    createNewCourier: 'Adicionar um estafeta',
    undefined: 'Não definido',
    list: {
      headerTable: {
        courierProfile: 'Entregador',
        courierId: 'Identificação do entregador',
        activationDate: 'Data de ativação',
        deactivationDate: 'Data de desativação',
        actions: 'Ações',
      },
      statusSrOnly: {
        active: 'Perfil de entregador ativo',
        inactive: 'Perfil de entregador inativo',
      },
      toggleStatus: {
        active: 'Ativar o perfil',
        inactive: 'Desativar o perfil',
      },
      edit: 'Editar perfil',
      empty: {
        title: 'Ainda não foi criado nenhum perfil de entregador.',
        text: 'Os perfis dos entregadores permitem-lhe atribuir as encomendas aos seus entregadores internos.',
      },
    },
    create: {
      couriersInformation: 'Informações do estafeta',
      title: 'Criar um perfil de entregador',
      name: 'Nome do estafeta*',
      nameAlreadyExistMessage: 'Este nome já existe. Adicione um elemento (por exemplo, um número) para o tornar único',
      id: 'Identificador de utilizador do estafeta',
      idExplaination:
        'O identificador permite que este perfil se ligue ao Iris. É criado automaticamente a partir do nome introduzido e das informações da sua loja para ser único.',
      profileCreated: 'O estafeta foi criado.',
      profileNotCreated: 'Impossível criar o estafeta',
      password: {
        label: 'Palavra-passe*',
        confirmLabel: 'Confirmar palavra-passe*',
        confirmNotMatch: 'Os dois campos não correspondem.',
        rules: {
          uppercase: 'Uma letra maiúscula',
          lowercase: 'Uma letra minúscula',
          number: 'Um número',
          minCaracters: 'Mais de 10 caracteres',
          specialCaracters: "Um caractere especial entre ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'O estado do entregador',
        explanation: {
          activation: {
            default: `O estafeta estará ativo a partir do dia de ativação selecionado.`,
            inactiv: 'O estafeta estará inativo.',
          },
          desactivation: {
            default: `O estafeta estará inativo a partir do dia de desativação selecionado.`,
            notDefine: `O estafeta permanecerá ativo até que o desative.`,
          },
          tomorrowTooltip: `A data de desativação não pode ser anterior à data de ativação.`,
        },
      },
      date: {
        activationTitle: `Data de ativação*`,
        desactivationTitle: 'Data de desativação*',
        today: `Hoje`,
        tomorrow: 'Amanhã',
        otherDate: 'Outra data',
        notDefine: 'Não definida',
        endDateBeforeStartDate: 'A data de desativação não pode ser anterior à data de ativação.',
      },
      error: {
        someFieldsNeedCorrection:
          'Algumas informações precisam de ser corrigidas. Por favor, verifique os campos assinalados.',
        someFieldsAreMissing: 'Algumas informações estão em falta. Por favor, verifique os campos assinalados.',
        fieldRequired: 'Este campo é obrigatório.',
        impossibleToCreate: 'Impossível criar o perfil do estafeta.',
      },
    },
    update: {
      title: 'Editar um perfil de estafeta',
      profileUpdated: 'O estafeta foi atualizado.',
      selectedCourier: 'O entregador selecionado',
      cancelButton: 'Manter o planeamento',
      activationButton: 'Ativar',
      deactivationButton: 'Desativar',
      password: {
        edit: 'Editar palavra-passe',
        label: 'Nova palavra-passe*',
        closeWithoutSaving: 'Fechar sem guardar',
      },
      error: {
        impossibleToUpdate: 'Impossível atualizar o perfil do estafeta.',
      },
      guidingMessage: {
        activation: 'Parece que já foi programada uma ativação para este e-mail!',
        deactivation: 'Parece que já foi programada uma desativação para este e-mail!',
        activationDate: 'Data prevista para ativação:',
        deactivationDate: 'Data prevista para desativação:',
        profileDeactivate: 'O estafeta foi desativado com sucesso',
        profileActivate: 'O estafeta foi ativado com sucesso',
        disableActions:
          'Para alterar o período de atividade ou eliminar este entregador, deve primeiro remover as encomendas que lhe estão associadas.',
      },
      modalTitle: {
        deactivation: 'Desativar o entregador',
        activation: 'Ativar o entregador',
      },
    },
    delete: {
      title: 'Eliminar um perfil de estafeta',
      button: 'Eliminar este estafeta',
      bodyTitle: 'Tem a certeza de que pretende eliminar este estafeta definitivamente?',
      profileDeleted: 'O estafeta foi eliminado com sucesso.',
      error: {
        impossibleToUpdate: 'Impossível eliminar o perfil do estafeta',
        activeOrders:
          'Este entregador ainda tem encomendas ativas em curso. Cancele ou reatribua essas encomendas no separador «Entrega» e, em seguida, tente novamente.',
      },
    },
    deliveryTab: {
      isActiv: 'Interno',
      isInactiv: 'Estafeta inativo',
    },
    assignation: {
      title: 'Entrega interna',
      activeProfiles: '{n} perfil ativo no dia da entrega',
      activeProfilesPlural: '{n} perfis ativos no dia da entrega',
      noActiveProfiles: 'Não há entregadores disponíveis',
      goToInternalCourierList: 'Abrir a gestão dos entregadores',
    },
    detail: 'Encomenda tratada internamente',
  },
  onboarding: {
    title: 'Tutorial',
    checkLater: 'Lembrar mais tarde',
    close: 'Fechar',
    startGuide: 'Começar',
    next: 'Seguinte',
    finishGuide: 'Percebi',
    readTime: 'Tempo estimado: {minutes} min',
    recipientConfirmation: {
      welcome: {
        title: 'Tutorial - Novidades',
        description: [
          'Adicionámos novas ferramentas à sua interface para lhe facilitar a vida no acompanhamento das suas encomendas e entregas. Deixe-se guiar para descobrir como funcionam!',
          'As novidades:',
          '1. SMS ao destinatário',
          '2. Fotografia na entrega',
          '3. Melhorias na apresentação',
        ].join('\n'),
      },
      step1: {
        title: 'Envio do SMS ao destinatário',
        description: [
          'O destinatário recebe automaticamente um SMS <strong>a pedir-lhe que confirme os seus dados e a sua presença na data e no horário pedidos.</strong>',
          'Envio do SMS: na véspera da entrega às 18h ou 30 min após a compra para as encomendas feitas no próprio dia.',
          '<br />',
          'Poupe tempo: se o destinatário confirmou, já não precisa de lhe ligar antes de sair para entregar!',
          'Caso contrário, faça a entrega como faz hoje.',
        ].join('\n'),
      },
      step2: {
        title: 'Estados do SMS',
        description: [
          'O SMS pode ter vários estados:',
          '1- "Validado" por SMS - está tudo ok, o ícone fica verde',
          'Uma vez validado, o destinatário já não pode alterar estas informações.',
          '2- "Validado" por telefone - Falou com o destinatário por telefone, valide o estado manualmente',
          '3- "Enviado" - o SMS foi enviado',
          '4- "Reenviado" - reenvie o SMS com um clique para dar ao destinatário uma segunda oportunidade de confirmar.',
          '5- "Expirado" - sem resposta 1h antes do fim do horário de entrega, o destinatário já não pode adicionar informações nem validar -> faça a entrega como faz hoje',
        ].join('\n'),
      },
      step3: {
        title: 'Novo estado "Pronta"',
        description: [
          'Depois de terminar a preparação do produto, coloque a encomenda no estado "Pronta" no iris: está pronto para a entregar.',
          'Nota: ',
          '- uma vez ativado o estado "Pronta", o destinatário já não pode adicionar informações',
          '- este estado está disponível no dia da entrega, a partir de 2h antes do início do horário de entrega',
        ].join('\n'),
      },
      step4: {
        title: 'Atualizações das informações da encomenda',
        description: [
          'Se o destinatário adicionar detalhes ou se a encomenda for alterada, aparece o ícone «i» roxo.',
          'Aceda com um clique ao histórico de alterações de uma encomenda.',
          'Clique no ícone «i» a partir da lista de encomendas para ver o que mudou e marcar a alteração como vista.',
          'Esta informação permanece disponível a qualquer momento.',
        ].join('\n'),
      },
      step5: {
        title: 'O destinatário aceita a entrega na sua ausência',
        description: [
          'O destinatário pode autorizar que a encomenda seja deixada na sua ausência, com eventuais informações adicionais. Ex.: no vizinho, à frente da porta, atrás do portão à direita...',
          'Encontre estas informações na página de detalhe da encomenda ou através do ícone «i»',
          'Neste caso específico, <strong>é necessária uma fotografia no momento da entrega, sem rostos visíveis. Protege-o em caso de litígio.</strong>',
        ].join('\n'),
      },
      step6: {
        title: 'Como tirar a fotografia?',
        description:
          'Quando confirma a entrega, aparece um ecrã. Lembre-se de deslizar para baixo com a barra lateral para fazer aparecer a opção FOTO',
      },
      step7: {
        title: 'Acompanhamento de impressões',
        description: 'A partir da lista de encomendas, veja num relance se as suas encomendas foram impressas.',
      },
      step8: {
        title: 'Cores de estado mais visíveis',
        description:
          'A cor foi reforçada em certas zonas das linhas de encomenda para distinguir melhor os estados, sem sobrecarregar a leitura do resto da linha.',
      },
    },
  },
};
